module.exports = __webpack_public_path__ + "static/visual_3_2_eg-4ff397da13191e68344cc0fefda384a9.png";